import React, { useContext, useEffect, useState } from "react";
import { NavLink, useParams, useNavigate, useLocation } from "react-router-dom";
import ExamContext from "../../../context/ExamContext";
import { padstart2 } from "../../../utils/time";
import Button from "../../../components/ui/Button";
import { isObjectEmpty } from "../../../utils/objects";
import LoadingIcon from "../../../components/ui/LoadingIcon";
import { useLanguage } from "../../../context/LanguageContext";

const ExamStatus = ({ handleResume, handleSubmit }) => {
    const { exam, minutes, seconds, questions, startExam, submitLoading, examStarted } =
        useContext(ExamContext);
    const [selected, setSelected] = useState(0);
    const [opened, setOpened] = useState(0);
    const { language } = useLanguage();

    const translations = {
        ar: {
            remaining_time: "باقي من الزمن",
            finish_exam: "إنهاء الاختبار",
            resume_exam: "استكمال الاختبار لاحقًا",
            total_score: "اجمالي درجات الامتحان :",
            total_questions: "عدد الاسئلة :",
            opened_questions: "عدد الاسئلة التي تم فتحها :",
            unanswered_questions: "عدد الاسئلة غير المحلولة :",
            answered_questions: "عدد الاسئلة المحلولة :",
            current_question: "السؤال الحالي :",
            loading_questions: "يتم الآن تحميل الاسئلة",
            prev: "السابق",
            next: "التالي",
        },
        en: {
            remaining_time: "Time Remaining",
            finish_exam: "Finish Exam",
            resume_exam: "Resume Exam Later",
            total_score: "Total Exam Score:",
            total_questions: "Total Questions:",
            opened_questions: "Opened Questions:",
            unanswered_questions: "Unanswered Questions:",
            answered_questions: "Answered Questions:",
            current_question: "Current Question:",
            loading_questions: "Loading Questions...",
            prev: "Previous",
            next: "Next",
        },
        de: {
            remaining_time: "Verbleibende Zeit",
            finish_exam: "Test beenden",
            resume_exam: "Test später fortsetzen",
            total_score: "Gesamtnote des Tests:",
            total_questions: "Gesamtanzahl der Fragen:",
            opened_questions: "Geöffnete Fragen:",
            unanswered_questions: "Unbeantwortete Fragen:",
            answered_questions: "Beantwortete Fragen:",
            current_question: "Aktuelle Frage:",
            loading_questions: "Fragen werden geladen...",
            prev: "Zurück",
            next: "Weiter",
        },
    };
    const { question_id } = useParams();

    const navigate = useNavigate();

    const location = useLocation();

    useEffect(() => {
        if (!question_id && startExam) {
            if (examStarted && questions.length > 0) {
                navigate("./questions/0");
                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 100);
            } else {
                window.location.reload();
            }
            // console.log(false);
            // setStartExam(false);
            // setExam(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [examStarted, question_id, questions.length, startExam]);

    useEffect(() => {
        if (questions.length > 0) {
            let selectedCount = 0;
            let openedCount = 0;
            questions.forEach((element) => {
                if (element.selected_answer) {
                    selectedCount++;
                    openedCount++;
                } else if (element.opened) {
                    openedCount++;
                }
            });
            setSelected(selectedCount);
            setOpened(openedCount);
        }
    }, [questions.length, questions, location.pathname]);

    const handleNavigate = (forward) => {
        if (questions.length < 1) return;
        let forwardTo = "";
        if (forward) {
            if (parseInt(question_id) + 1 === questions.length) {
                forwardTo = "questions/0";
            } else {
                forwardTo = "questions/" + (parseInt(question_id) + 1);
            }
        } else {
            if (parseInt(question_id) === 0) {
                forwardTo = "questions/" + (questions.length - 1);
            } else {
                forwardTo = "questions/" + (parseInt(question_id) - 1);
            }
        }
        navigate(forwardTo);
    };
    return (
        <>
            {!isObjectEmpty(exam) && startExam ? (
                <div className="flex-center-both">
                    <div className="rounded-md bg-third-container px-5 py-2 shadow-md w-full max-w-2xl space-y-3 smooth clr-text-primary border border-secondary-container">
                        {questions.length > 0 ? (
                            <>
                                <div className="flex-center-both">
                                    <div className="bg-rose-500 rounded-md font-w-bold font-com font-h3 en space-y-1 px-3 clr-white pt-1 pb-2">
                                        <div className="bg-third-container font-smaller font-alm flex-center-both rounded-md px-2 pb-1 clr-text-secondary smooth">
                                            {translations[language].remaining_time}
                                        </div>
                                        <div className="flex space-x-2 flex-center-both">
                                            <div>{padstart2(minutes)}</div>
                                            <div className="font-com -mt-0.5">:</div>
                                            <div>{padstart2(seconds)}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-full max-w-xs mx-auto py-3 space-y-5">
                                    <Button
                                        color="blue"
                                        className="w-full"
                                        isLoading={submitLoading}
                                        onClick={handleSubmit}
                                    >
                                        {translations[language].finish_exam}
                                    </Button>
                                    {exam.sectionable.is_continuable ? (
                                        <Button
                                            color="yellow"
                                            isLoading={submitLoading}
                                            className="w-full"
                                            onClick={handleResume}
                                        >
                                            {translations[language].resume_exam}
                                        </Button>
                                    ) : (
                                        ""
                                    )}
                                </div>
                                <div className="flex-center-both flex-col max-w-xs mx-auto space-y-2">
                                    <div className="flex justify-between w-full">
                                        <div>{translations[language].total_score}</div>
                                        <div className="flex-center-both">
                                            <div className="rounded-md bg-primary-container smooth clr-text-primary px-2 py-1">
                                                {exam.exam_result
                                                    ? exam.exam_result.full_result
                                                    : ""}
                                                {/* {console.log(exam)} */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex justify-between w-full">
                                        <div>{translations[language].total_questions}</div>
                                        <div className="flex-center-both">
                                            <div className="rounded-md bg-primary-container smooth clr-text-primary px-2 py-1">
                                                {questions.length}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex justify-between w-full">
                                        <div>{translations[language].opened_questions}</div>
                                        <div className="flex-center-both">
                                            <div className="rounded-md bg-yellow-500 clr-white px-2 py-1">
                                                {opened}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex justify-between w-full">
                                        <div>{translations[language].unanswered_questions}</div>
                                        <div className="flex-center-both">
                                            <div className="rounded-md bg-rose-500 clr-white px-2 py-1">
                                                {opened - selected}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex justify-between w-full">
                                        <div>{translations[language].answered_questions}</div>
                                        <div className="flex-center-both">
                                            <div className="rounded-md bg-blue-500 clr-white px-2 py-1">
                                                {selected}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="h-px max-w-sm w-full bg-text-secondary smooth mx-auto opacity-50"></div>
                                    <div className="flex justify-between w-full">
                                        <div>{translations[language].current_question}</div>
                                        <div className="flex-center-both">
                                            <div className="rounded-md bg-primary-container smooth clr-text-primary px-2 py-1 border-2 border-rose-500">
                                                {question_id ? parseInt(question_id) + 1 : ""}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid grid-cols-12 gap-1 ">
                                    {questions.length > 0 &&
                                        questions.map((value, index) => {
                                            return (
                                                <NavLink
                                                    className={({ isActive }) =>
                                                        `smooth ${
                                                            isActive
                                                                ? "rounded-lg border-2 border-blue-500 border-opacity-100"
                                                                : "rounded-lg border-2 border-opacity-0 border-slate-300 dark:border-slate-900 dark:border-opacity-0"
                                                        }`
                                                    }
                                                    to={`questions/${index}`}
                                                    key={index}
                                                >
                                                    <div
                                                        className={`rounded-md ${
                                                            value.selected_answer
                                                                ? "bg-blue-400"
                                                                : value.opened
                                                                ? "bg-rose-500"
                                                                : "bg-slate-400"
                                                        } clr-white hover-shadow flex-center-both smooth`}
                                                    >
                                                        {index + 1}
                                                    </div>
                                                </NavLink>
                                            );
                                        })}
                                </div>
                                <div className="h-px max-w-sm w-full bg-text-secondary smooth mx-auto opacity-50"></div>
                                <div className="">
                                    <div className="flex-center-both gap-4">
                                        <Button onClick={() => handleNavigate(false)}>
                                            {translations[language].prev}
                                        </Button>
                                        <Button
                                            onClick={() => handleNavigate(true)}
                                            className="px-6 py-2"
                                        >
                                            {translations[language].next}
                                        </Button>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <span className="flex space-x-reverse space-x-4 font-h3 flex-center-both w-full py-5">
                                    <LoadingIcon className={"font-h1 text-blue-500"} />
                                    <span>{translations[language].loading_questions}</span>
                                </span>
                            </>
                        )}
                    </div>
                </div>
            ) : (
                ""
            )}
        </>
    );
};

export default ExamStatus;
